import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthService } from '../auth.service';

@Injectable()
export class AuthGuardClientes implements CanActivate {

    constructor(private router: Router, private authService: AuthService) { }

    canActivate() {        
        if (this.authService.token && this.authService.roles.indexOf("usuario") > -1) {
            // logged in so return true
            return true;
        }

        // not logged in so redirect to login page
        this.router.navigate(['/login']);
        return false;
    }
}



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/app/services/guards/auth-guard.clientes.ts